// This allows us to define a publish schedule in advance and have these promos show/hide.
// The schedule is based on the current date and time. EX: unpublish_at: "2025-03-19T16:42:00" // please use this example set the time if needed

const promoDrawsScheduleConfig = {
  // Promo Draws
  // "C362B105-A0B8-4F1E-B8DB-BF3FC3CAA2D5": {
  //   key: "examplePromo1",
  //   publish_at: "2024-03-10T11:30:00",
  //   unpublish_at: "2025-07-20T20:00:00",
  //   draw_end: "2025-03-20T20:05:00"
  // },
  // "EA2917A2-2D69-4E51-9E9E-A532CADCF887": {
  //   key: "examplePromo2",
  //   publish_at: "2024-03-24T11:30:00",
  //   unpublish_at: "2025-04-16T20:00:00",
  //   draw_end: "2025-04-11T22:05:00"
  // },
  // "D1C1B0B0-8E66-4E59-BD6A-92DB1196B25D": {
  //   key: "1DayTestForWebsite",
  //   publish_at: "2025-04-01T08:00:00",
  //   unpublish_at: "2025-06-02T18:00:00",
  //   draw_end: "2025-06-02T00:00:00-04:00" // TODO: Double check timezone on all these config dates
  // },
  // "1E0D1EA7-46BE-45D3-B99E-DDA84BED2DFE": {
  // "3BD44206-2BD6-44E1-8845-01C7A839ADF6": {
  //   key: "multiMillionaireMaker2025",
  //   drawType: "poker",
  //   publish_at: "2025-04-01T08:00:00",
  //   unpublish_at: "2025-06-02T18:00:00",
  //   earning_start: "2025-04-01T08:00:00", // Use the Eastern time that we need, but dont add the -04:00
  //   earning_end: "2025-06-01T23:59:59", // Use the Eastern time that we need, but dont add the -04:00
  //   draw_end: "2025-06-02T00:00:00" // Use the Eastern time that we need, but dont add the -04:00
  // },
  "465": {
    key: "hockeyNightAtPlayground2025",
    drawType: "egd",
    publish_at: "2025-10-30T09:00:00",
    earning_start: "2025-10-30T09:00:00", // Use the Eastern time that we need, but dont add the -04:00
    earning_end: "2025-11-30T19:30:00", // Use the Eastern time that we need, but dont add the -04:00
    draw_end: "2025-11-30T20:45:00", // Use the Eastern time that we need, but dont add the -04:00
    unpublish_at: "2025-11-30T21:00:00"
  },
  "8B5BFDD4-8BAE-4C7D-9D65-9759E341D8A5": {
    key: "multiMillionaireMakerSeptember2025",
    drawType: "poker",
    publish_at: "2025-09-04T13:00:00",
    earning_start: "2025-09-08T09:00:00", // Use the Eastern time that we need, but dont add the -04:00
    earning_end: "2025-09-28T09:00:00", // Use the Eastern time that we need, but dont add the -04:00
    draw_end: "2025-09-28T19:00:00", // Use the Eastern time that we need, but dont add the -04:00
    unpublish_at: "2025-09-28T19:00:00"
  },
  // Triple Barrel Cash Blast Anniversary Edition multi-draw promotion
  "TRIPLE-BARREL-BLAST-ANNIVERSARY-2025": {
    key: "tripleBarrelCashBlast2025AnniversaryEdition",
    drawType: "poker",
    isMultiDraw: true,
    subDraws: [
      {
        promotionId: "80CBC919-913E-496C-8EB6-8B2A42F4A7FF",
        labelKey: "silver"
      },
      {
        promotionId: "63442915-6018-4785-981E-505784302B49",
        labelKey: "gold"
      },
      {
        promotionId: "BBD9388B-6D86-4EF3-8909-8B2ABBA3D5A9",
        labelKey: "diamond"
      }
    ],
    publish_at: "2025-11-12",
    earning_start: "2025-11-19T08:00:00",
    earning_end: "2025-12-17T08:00:00",
    draw_end: "2025-12-17T22:00:00",
    unpublish_at: "2025-12-18T01:30:00"
  },
    // Triple Barrel Cash Blast 2026 multi-draw promotion
  "TRIPLE-BARREL-BLAST-2026": {
    key: "tripleBarrelCashBlast2026",
    drawType: "poker",
    isMultiDraw: true,
    subDraws: [
      {
        promotionId: "467100A2-3889-443B-B328-B157002F2258",
        labelKey: "silver"
      },
      {
        promotionId: "CC4EB1FA-5D6C-449A-820A-43A306159FC4",
        labelKey: "gold"
      },
      {
        promotionId: "DCBF21CC-BBDA-4F4D-AB1F-9DE1A9E78AA7",
        labelKey: "diamond"
      }
    ],
    publish_at: "2025-12-12",
    earning_start: "2025-12-18T08:00:00",
    earning_end: "2026-01-18T21:55:00",
    draw_end: "2026-01-18T22:00:00",
    unpublish_at: "2026-01-18T22:00:00"
  },
  // Triple Barrel Cash Blast February 2026 multi-draw promotion
  "TRIPLE-BARREL-BLAST-FEBRUARY-2026": {
    key: "tripleBarrelCashBlastFebruary2026",
    drawType: "poker",
    isMultiDraw: true,
    subDraws: [
      {
        promotionId: "TBD-SILVER-FEB2026",
        labelKey: "silver"
      },
      {
        promotionId: "TBD-GOLD-FEB2026",
        labelKey: "gold"
      },
      {
        promotionId: "TBD-DIAMOND-FEB2026",
        labelKey: "diamond"
      }
    ],
    publish_at: "2026-01-15",
    earning_start: "2026-01-19T08:00:00",
    earning_end: "2026-03-01T21:55:00",
    draw_end: "2026-03-01T22:00:00",
    unpublish_at: "2026-03-01T22:00:00"
  },
  // Club Elite Saturday Draws - Week 2 (Nov 15)
  "CLUB-ELITE-WEEK-2-2025": {
    key: "clubEliteWeek2",
    drawType: "egd",
    isMultiDraw: true,
    mergeTickets: true,
    publish_at:     "2025-11-08T18:00:00",
    earning_start:  "2025-11-09T00:00:00", // Sunday 12:00 AM
    earning_end:    "2025-11-15T15:59:59", // Saturday 3:59 PM
    draw_end:       "2025-11-15T17:00:00",
    unpublish_at:   "2025-11-15T18:00:00",
    subDraws: [
      { promotionId: "458" },
      { promotionId: "462" }
    ]
  },
  // Club Elite Saturday Draws - Week 3 (Nov 22)
  "CLUB-ELITE-WEEK-3-2025": {
    key: "clubEliteWeek3",
    drawType: "egd",
    isMultiDraw: true,
    mergeTickets: true,
    publish_at:     "2025-11-15T18:00:00",
    earning_start:  "2025-11-16T00:00:00", // Sunday 12:00 AM
    earning_end:    "2025-11-22T15:59:59", // Saturday 3:59 PM
    draw_end:       "2025-11-22T17:00:00",
    unpublish_at:   "2025-11-22T18:00:00",
    subDraws: [
      { promotionId: "459" },
      { promotionId: "463" }
    ]
  },
  // Club Elite Saturday Draws - Week 4 (Nov 29)
  "CLUB-ELITE-WEEK-4-2025": {
    key: "clubEliteWeek4",
    drawType: "egd",
    isMultiDraw: true,
    mergeTickets: true,
    publish_at:     "2025-11-22T18:00:00",
    earning_start:  "2025-11-23T00:00:00", // Sunday 12:00 AM
    earning_end:    "2025-11-29T15:59:59", // Saturday 3:59 PM
    draw_end:       "2025-11-29T17:00:00",
    unpublish_at:   "2025-11-29T18:00:00",
    subDraws: [
      { promotionId: "460" },
      { promotionId: "464" }
    ]
  }
};

export default promoDrawsScheduleConfig;
